import React from "react";
import Marquee from "react-fast-marquee";
import MickeyEars from "./MickeyEars";

const PHRASES = [
    "Oh boy!",
    "Festa do Mickey",
    "Hot dog! Hot dog!",
    "Christopher faz aniversário",
    "Venha brincar",
    "12 de Julho",
    "Tree House Indoor Play",
    "1:30 PM",
];

export const PartyMarquee = () => {
    return (
        <div
            data-testid="party-marquee"
            className="bg-secondary text-secondary-foreground border-y-4 border-black py-4 sm:py-5 overflow-hidden"
        >
            <Marquee gradient={false} speed={55} pauseOnHover>
                {PHRASES.concat(PHRASES).map((p, i) => (
                    <span
                        key={i}
                        className="font-heading text-2xl sm:text-3xl uppercase tracking-tight mx-8 inline-flex items-center gap-6"
                    >
                        {p}
                        <MickeyEars size={28} />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default PartyMarquee;
